import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Swal from 'sweetalert2';

const API_BASE_URL = process.env.REACT_APP_BASE_URL


export const fetchPhotography = createAsyncThunk(
  'photography/fetchPhotography',
  async (data, { rejectWithValue }) => {
    let {page,limit} = data
    try {
      const response = await axios.get(`${API_BASE_URL}/Photography/fetch`, {
        params: {
          page,
          limit
        }
      });
      //console.log('response', response.data);
    
      return response.data;
    } catch (error) {
    
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchPhotographyByCategory = createAsyncThunk(
  'photography/fetchPhotographyByCategory',
  async (data, { rejectWithValue }) => {
    let {category,page,limit} = data
    try {
      const response = await axios.get(`${API_BASE_URL}/Photography/fetch/category/${category}`, {
        params: {
          page,
          limit
        }
      });
      //console.log('response', response.data);
    
      return response.data;
    } catch (error) {
    
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchPhotographyById = createAsyncThunk(
  'photography/fetchPhotographyById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Photography/fetch/${id}`);
      //console.log('response',response)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);